import { render } from "./StandardContentShow.vue?vue&type=template&id=cb019018"
import script from "./StandardContentShow.vue?vue&type=script&lang=js"
export * from "./StandardContentShow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__